<template>
    <HomeComp></HomeComp>
  </template>
  <script>
  import HomeComp from "../components/Home.vue";
  
  export default {
    name: "Company Statistics Report",
    components: { HomeComp },
    computed: {},
    mounted() {},
  };
  </script>
  